import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';

// ─── SVG Exercise Illustrations ───────────────────────────────────────────────
const ExerciseSVG = ({ exerciseName }) => {
  const svgs = {
    'Barbell Back Squat': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar */}
        <rect x="10" y="28" width="100" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="8" y="25" width="8" height="11" rx="2" fill="#818cf8"/>
        <rect x="104" y="25" width="8" height="11" rx="2" fill="#818cf8"/>
        {/* Body - squat position */}
        <circle cx="60" cy="20" r="8" fill="#a78bfa" opacity="0.9"/>
        {/* Torso */}
        <path d="M52 28 Q60 33 68 28 L66 52 Q60 55 54 52 Z" fill="#7c3aed" opacity="0.7"/>
        {/* Upper arms */}
        <line x1="52" y1="30" x2="30" y2="33" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="68" y1="30" x2="90" y2="33" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Thighs - parallel */}
        <path d="M54 52 L40 75" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <path d="M66 52 L80 75" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        {/* Shins */}
        <path d="M40 75 L44 92" stroke="#6d28d9" strokeWidth="4" strokeLinecap="round"/>
        <path d="M80 75 L76 92" stroke="#6d28d9" strokeWidth="4" strokeLinecap="round"/>
        {/* Feet */}
        <ellipse cx="44" cy="93" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="76" cy="93" rx="6" ry="3" fill="#5b21b6"/>
        {/* Muscle highlight - quads */}
        <path d="M54 52 L40 75" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
        <path d="M66 52 L80 75" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
        {/* Depth arrow */}
        <path d="M18 55 L18 75" stroke="#10b981" strokeWidth="1.5" strokeDasharray="3,2"/>
        <text x="4" y="66" fontSize="6" fill="#10b981">↕</text>
        <text x="2" y="73" fontSize="5" fill="#10b981">90°</text>
      </svg>
    ),
    'Romanian Deadlift': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar */}
        <rect x="30" y="72" width="60" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="28" y="69" width="7" height="11" rx="2" fill="#818cf8"/>
        <rect x="85" y="69" width="7" height="11" rx="2" fill="#818cf8"/>
        {/* Head */}
        <circle cx="60" cy="18" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso - hinged forward */}
        <path d="M60 25 L60 55" stroke="#7c3aed" strokeWidth="6" strokeLinecap="round"/>
        {/* Arms hanging */}
        <line x1="57" y1="35" x2="50" y2="72" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="63" y1="35" x2="70" y2="72" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Legs - slight bend */}
        <path d="M57 55 L50 80 L52 95" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <path d="M63 55 L70 80 L68 95" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        {/* Feet */}
        <ellipse cx="52" cy="95" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="68" cy="95" rx="6" ry="3" fill="#5b21b6"/>
        {/* Hamstring highlight */}
        <path d="M57 55 L50 80" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
        <path d="M63 55 L70 80" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
        {/* Hinge arrow */}
        <path d="M75 25 Q85 40 80 55" stroke="#10b981" strokeWidth="1.5" fill="none" strokeDasharray="3,2"/>
        <text x="82" y="30" fontSize="6" fill="#10b981">hinge</text>
      </svg>
    ),
    'Barbell Bench Press': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bench */}
        <rect x="20" y="65" width="80" height="8" rx="3" fill="#374151"/>
        <rect x="25" y="73" width="6" height="15" rx="2" fill="#374151"/>
        <rect x="89" y="73" width="6" height="15" rx="2" fill="#374151"/>
        {/* Bar */}
        <rect x="15" y="35" width="90" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="12" y="32" width="8" height="11" rx="2" fill="#818cf8"/>
        <rect x="100" y="32" width="8" height="11" rx="2" fill="#818cf8"/>
        {/* Body lying */}
        <circle cx="60" cy="58" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso */}
        <rect x="40" y="60" width="40" height="12" rx="4" fill="#7c3aed" opacity="0.7"/>
        {/* Arms pressing */}
        <line x1="44" y1="62" x2="28" y2="40" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="76" y1="62" x2="92" y2="40" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Chest highlight */}
        <ellipse cx="60" cy="64" rx="16" ry="5" fill="#f59e0b" opacity="0.3"/>
        {/* Legs */}
        <line x1="45" y1="72" x2="38" y2="90" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        <line x1="64" y1="72" x2="70" y2="90" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        <ellipse cx="38" cy="91" rx="5" ry="3" fill="#5b21b6"/>
        <ellipse cx="70" cy="91" rx="5" ry="3" fill="#5b21b6"/>
        {/* Press arrow */}
        <path d="M60 55 L60 42" stroke="#10b981" strokeWidth="1.5" markerEnd="url(#arrow)"/>
        <text x="62" y="48" fontSize="6" fill="#10b981">press</text>
      </svg>
    ),
    'Overhead Press (OHP)': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar overhead */}
        <rect x="15" y="12" width="90" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="12" y="9" width="8" height="11" rx="2" fill="#818cf8"/>
        <rect x="100" y="9" width="8" height="11" rx="2" fill="#818cf8"/>
        {/* Head */}
        <circle cx="60" cy="28" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso */}
        <rect x="52" y="35" width="16" height="25" rx="4" fill="#7c3aed" opacity="0.7"/>
        {/* Arms extended up */}
        <line x1="54" y1="38" x2="28" y2="17" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="66" y1="38" x2="92" y2="17" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Shoulder highlight */}
        <circle cx="52" cy="37" r="5" fill="#f59e0b" opacity="0.4"/>
        <circle cx="68" cy="37" r="5" fill="#f59e0b" opacity="0.4"/>
        {/* Legs */}
        <line x1="56" y1="60" x2="50" y2="82" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <line x1="64" y1="60" x2="70" y2="82" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <ellipse cx="50" cy="83" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="70" cy="83" rx="6" ry="3" fill="#5b21b6"/>
        {/* Core brace indicator */}
        <path d="M48 45 Q60 48 72 45" stroke="#10b981" strokeWidth="1.5" fill="none" strokeDasharray="2,2"/>
        <text x="50" y="55" fontSize="5" fill="#10b981">brace core</text>
      </svg>
    ),
    'Pull-ups / Lat Pulldown': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar */}
        <rect x="20" y="10" width="80" height="5" rx="2.5" fill="#374151"/>
        {/* Hands gripping */}
        <circle cx="35" cy="15" r="4" fill="#a78bfa"/>
        <circle cx="85" cy="15" r="4" fill="#a78bfa"/>
        {/* Arms */}
        <line x1="35" y1="19" x2="48" y2="35" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="85" y1="19" x2="72" y2="35" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Head */}
        <circle cx="60" cy="32" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso */}
        <rect x="52" y="39" width="16" height="22" rx="4" fill="#7c3aed" opacity="0.7"/>
        {/* Lat highlight */}
        <path d="M48 35 Q44 50 52 58" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
        <path d="M72 35 Q76 50 68 58" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
        {/* Legs hanging */}
        <line x1="56" y1="61" x2="52" y2="85" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        <line x1="64" y1="61" x2="68" y2="85" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        <ellipse cx="52" cy="86" rx="5" ry="3" fill="#5b21b6"/>
        <ellipse cx="68" cy="86" rx="5" ry="3" fill="#5b21b6"/>
        {/* Elbow drive arrow */}
        <path d="M45 30 L50 42" stroke="#10b981" strokeWidth="1.5" strokeDasharray="2,2"/>
        <text x="20" y="45" fontSize="5" fill="#10b981">elbows↓</text>
      </svg>
    ),
    'Barbell Bent-Over Row': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar */}
        <rect x="28" y="62" width="64" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="25" y="59" width="7" height="11" rx="2" fill="#818cf8"/>
        <rect x="88" y="59" width="7" height="11" rx="2" fill="#818cf8"/>
        {/* Head */}
        <circle cx="60" cy="20" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso - ~45° hinge */}
        <path d="M60 27 L60 55" stroke="#7c3aed" strokeWidth="6" strokeLinecap="round"/>
        {/* Arms pulling to chest */}
        <line x1="55" y1="40" x2="40" y2="64" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="65" y1="40" x2="80" y2="64" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Back/lat highlight */}
        <path d="M55 30 Q48 42 52 52" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
        <path d="M65 30 Q72 42 68 52" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
        {/* Legs */}
        <path d="M57 55 L50 78 L52 92" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <path d="M63 55 L70 78 L68 92" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <ellipse cx="52" cy="93" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="68" cy="93" rx="6" ry="3" fill="#5b21b6"/>
        {/* Pull arrow */}
        <path d="M60 65 L60 45" stroke="#10b981" strokeWidth="1.5" strokeDasharray="2,2"/>
        <text x="62" y="55" fontSize="5" fill="#10b981">pull↑</text>
      </svg>
    ),
    'Hip Thrust': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bench */}
        <rect x="10" y="48" width="40" height="8" rx="3" fill="#374151"/>
        {/* Bar across hips */}
        <rect x="25" y="38" width="70" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="22" y="35" width="7" height="11" rx="2" fill="#818cf8"/>
        <rect x="91" y="35" width="7" height="11" rx="2" fill="#818cf8"/>
        {/* Head on bench */}
        <circle cx="25" cy="44" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso - hips up */}
        <path d="M32 48 L60 40 L75 48" stroke="#7c3aed" strokeWidth="6" strokeLinecap="round"/>
        {/* Glute highlight */}
        <ellipse cx="60" cy="40" rx="12" ry="6" fill="#f59e0b" opacity="0.4"/>
        {/* Legs */}
        <path d="M75 48 L90 70 L88 88" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <path d="M68 48 L72 70 L70 88" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <ellipse cx="88" cy="89" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="70" cy="89" rx="6" ry="3" fill="#5b21b6"/>
        {/* Squeeze indicator */}
        <text x="50" y="36" fontSize="5" fill="#10b981">squeeze!</text>
        <path d="M60 30 L60 22" stroke="#10b981" strokeWidth="1.5" strokeDasharray="2,2"/>
      </svg>
    ),
    'Deadlift': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Bar on floor */}
        <rect x="20" y="75" width="80" height="5" rx="2.5" fill="#6366f1" opacity="0.8"/>
        <rect x="17" y="68" width="9" height="19" rx="3" fill="#818cf8"/>
        <rect x="94" y="68" width="9" height="19" rx="3" fill="#818cf8"/>
        {/* Head */}
        <circle cx="60" cy="18" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso - slight hinge */}
        <path d="M60 25 L60 55" stroke="#7c3aed" strokeWidth="6" strokeLinecap="round"/>
        {/* Arms */}
        <line x1="55" y1="38" x2="48" y2="77" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="65" y1="38" x2="72" y2="77" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Legs */}
        <path d="M56 55 L48 78" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <path d="M64 55 L72 78" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        {/* Posterior chain highlight */}
        <path d="M60 25 L60 55" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
        <path d="M56 55 L48 78" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
        {/* Bar path arrow */}
        <path d="M80 75 L80 30" stroke="#10b981" strokeWidth="1.5" strokeDasharray="2,2"/>
        <text x="82" y="50" fontSize="5" fill="#10b981">bar close</text>
      </svg>
    ),
    'Burpees': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Phase 1: standing jump */}
        <circle cx="25" cy="15" r="5" fill="#a78bfa" opacity="0.6"/>
        <line x1="25" y1="20" x2="25" y2="35" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="25" y1="35" x2="18" y2="45" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="25" y1="35" x2="32" y2="45" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <text x="15" y="55" fontSize="5" fill="#6366f1">jump</text>
        {/* Arrow */}
        <path d="M38 30 L52 30" stroke="#10b981" strokeWidth="1.5" markerEnd="url(#a)"/>
        {/* Phase 2: plank */}
        <circle cx="65" cy="45" r="5" fill="#a78bfa" opacity="0.8"/>
        <path d="M70 47 L95 50" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="85" y1="50" x2="88" y2="60" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="92" y1="51" x2="95" y2="61" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="70" y1="47" x2="65" y2="57" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <text x="62" y="68" fontSize="5" fill="#6366f1">plank</text>
        {/* Arrow */}
        <path d="M38 65 L52 65" stroke="#10b981" strokeWidth="1.5"/>
        {/* Phase 3: push-up */}
        <circle cx="20" cy="72" r="5" fill="#a78bfa" opacity="0.8"/>
        <path d="M25 74 L45 78" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="35" y1="78" x2="37" y2="88" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="42" y1="79" x2="44" y2="89" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <line x1="25" y1="74" x2="22" y2="84" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round"/>
        <text x="12" y="96" fontSize="5" fill="#6366f1">push-up</text>
        {/* Full body label */}
        <text x="60" y="90" fontSize="6" fill="#f59e0b" fontWeight="bold">FULL BODY</text>
      </svg>
    ),
    'Plank': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Floor */}
        <line x1="10" y1="80" x2="110" y2="80" stroke="#374151" strokeWidth="2"/>
        {/* Body in plank */}
        <circle cx="25" cy="55" r="7" fill="#a78bfa" opacity="0.9"/>
        {/* Torso - straight line */}
        <path d="M32 58 L90 62" stroke="#7c3aed" strokeWidth="7" strokeLinecap="round"/>
        {/* Forearms */}
        <line x1="32" y1="58" x2="28" y2="78" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="42" y1="59" x2="38" y2="79" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Legs */}
        <line x1="90" y1="62" x2="95" y2="79" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        <line x1="82" y1="62" x2="87" y2="79" stroke="#7c3aed" strokeWidth="4" strokeLinecap="round"/>
        {/* Core highlight */}
        <path d="M50 59 L75 61" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
        {/* Straight line indicator */}
        <path d="M25 50 L95 55" stroke="#10b981" strokeWidth="1" strokeDasharray="3,2" opacity="0.8"/>
        <text x="30" y="45" fontSize="5" fill="#10b981">straight line head→heels</text>
        {/* Glute squeeze */}
        <circle cx="85" cy="62" r="6" fill="#f59e0b" opacity="0.3"/>
        <text x="78" y="72" fontSize="5" fill="#f59e0b">squeeze</text>
      </svg>
    ),
    'default': (
      <svg viewBox="0 0 120 100" className="w-full h-full" fill="none">
        {/* Generic figure */}
        <circle cx="60" cy="20" r="9" fill="#a78bfa" opacity="0.9"/>
        {/* Torso */}
        <rect x="52" y="29" width="16" height="25" rx="4" fill="#7c3aed" opacity="0.7"/>
        {/* Arms */}
        <line x1="52" y1="33" x2="36" y2="48" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        <line x1="68" y1="33" x2="84" y2="48" stroke="#a78bfa" strokeWidth="4" strokeLinecap="round"/>
        {/* Legs */}
        <line x1="56" y1="54" x2="48" y2="78" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <line x1="64" y1="54" x2="72" y2="78" stroke="#7c3aed" strokeWidth="5" strokeLinecap="round"/>
        <ellipse cx="48" cy="79" rx="6" ry="3" fill="#5b21b6"/>
        <ellipse cx="72" cy="79" rx="6" ry="3" fill="#5b21b6"/>
        {/* Dumbbell */}
        <rect x="30" y="46" width="12" height="4" rx="2" fill="#6366f1"/>
        <rect x="28" y="44" width="4" height="8" rx="1" fill="#818cf8"/>
        <rect x="38" y="44" width="4" height="8" rx="1" fill="#818cf8"/>
        {/* Muscle highlight */}
        <circle cx="52" cy="35" r="5" fill="#f59e0b" opacity="0.3"/>
        <circle cx="68" cy="35" r="5" fill="#f59e0b" opacity="0.3"/>
      </svg>
    ),
  };

  return svgs?.[exerciseName] || svgs?.['default'];
};

// ─── Muscle Activation Bar ─────────────────────────────────────────────────────
const MuscleActivationBar = ({ muscle, level }) => {
  const colors = {
    primary: 'bg-orange-500',
    secondary: 'bg-blue-400',
    stabilizer: 'bg-green-400',
  };
  const widths = { primary: 'w-full', secondary: 'w-3/4', stabilizer: 'w-1/2' };
  const labels = { primary: 'Primary', secondary: 'Secondary', stabilizer: 'Stabilizer' };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-foreground/80 w-28 flex-shrink-0 truncate">{muscle}</span>
      <div className="flex-1 h-1.5 bg-muted/50 rounded-full overflow-hidden">
        <div className={`h-full rounded-full ${colors?.[level]} ${widths?.[level]} transition-all duration-500`} />
      </div>
      <span className={`text-xs font-medium w-16 text-right ${level === 'primary' ? 'text-orange-500' : level === 'secondary' ? 'text-blue-400' : 'text-green-400'}`}>
        {labels?.[level]}
      </span>
    </div>
  );
};

// ─── Exercise Data with enhanced content ──────────────────────────────────────
const EXERCISE_DETAILS = {
  'Barbell Back Squat': {
    steps: [
      'Set bar on rack at upper-chest height. Step under bar, rest it on upper traps (not neck).',
      'Grip bar slightly wider than shoulders, unrack and step back with feet shoulder-width apart.',
      'Take a deep breath, brace core hard (360° pressure), and initiate descent by pushing knees out.',
      'Descend until thighs are parallel to floor — keep chest tall and weight in mid-foot.',
      'Drive through heels explosively, pushing knees out, until fully standing. Exhale at top.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Knees caving inward (valgus collapse) — cue: push knees out over pinky toe' },
      { icon: '⚠️', text: 'Heels rising off floor — fix: improve ankle mobility or use heel wedge' },
      { icon: '⚠️', text: 'Forward torso lean — often caused by tight hips or weak upper back' },
      { icon: '⚠️', text: 'Half reps — not reaching parallel reduces glute and hamstring activation' },
    ],
    activation: [
      { muscle: 'Quadriceps', level: 'primary' },
      { muscle: 'Glutes', level: 'primary' },
      { muscle: 'Hamstrings', level: 'secondary' },
      { muscle: 'Core / Spinal Erectors', level: 'secondary' },
      { muscle: 'Calves', level: 'stabilizer' },
    ],
  },
  'Romanian Deadlift': {
    steps: [
      'Stand with feet hip-width, hold barbell at hip level with overhand grip.',
      'Soft bend in knees — maintain this throughout. Push hips back as you lower the bar.',
      'Bar travels close to legs, feeling a deep stretch in hamstrings (usually mid-shin level).',
      'Keep back flat, chest up, and neck neutral throughout the entire movement.',
      'Drive hips forward to return to standing. Squeeze glutes at the top.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Rounding the lower back — keep spine neutral, hinge from hips not waist' },
      { icon: '⚠️', text: 'Bar drifting away from body — keep it dragging along your legs' },
      { icon: '⚠️', text: 'Bending knees too much — this turns it into a regular deadlift' },
      { icon: '⚠️', text: 'Not feeling the stretch — if no hamstring pull, you\'re not hinging enough' },
    ],
    activation: [
      { muscle: 'Hamstrings', level: 'primary' },
      { muscle: 'Glutes', level: 'primary' },
      { muscle: 'Spinal Erectors', level: 'secondary' },
      { muscle: 'Traps / Lats', level: 'stabilizer' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Leg Press': {
    steps: [
      'Sit in machine with lower back flat against pad. Place feet shoulder-width on platform.',
      'Release safety handles. Lower weight by bending knees until they reach ~90°.',
      'Keep feet flat on platform — don\'t let heels rise.',
      'Press through heels and mid-foot to extend legs. Stop just before knees lock out.',
      'Control the descent — don\'t let the weight crash down.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Locking out knees at top — keeps tension on quads and protects joints' },
      { icon: '⚠️', text: 'Lower back lifting off pad — reduce range of motion if this happens' },
      { icon: '⚠️', text: 'Feet too high = more hamstrings/glutes; too low = more quads — adjust per goal' },
      { icon: '⚠️', text: 'Knees caving inward — push knees out in line with toes throughout' },
    ],
    activation: [
      { muscle: 'Quadriceps', level: 'primary' },
      { muscle: 'Glutes', level: 'secondary' },
      { muscle: 'Hamstrings', level: 'secondary' },
      { muscle: 'Calves', level: 'stabilizer' },
    ],
  },
  'Walking Lunges': {
    steps: [
      'Stand tall, feet together. Step forward with one leg into a long stride.',
      'Lower back knee toward floor — stop just before it touches. Front shin stays vertical.',
      'Keep torso upright, core braced, and gaze forward throughout.',
      'Push off front foot and bring back leg forward to step into the next lunge.',
      'Alternate legs with each step. Hold dumbbells at sides for added resistance.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Front knee shooting past toes — step longer to keep shin vertical' },
      { icon: '⚠️', text: 'Torso leaning forward — keep chest up and core tight' },
      { icon: '⚠️', text: 'Short stride — too short reduces glute activation significantly' },
      { icon: '⚠️', text: 'Rushing the movement — control both descent and ascent for max muscle work' },
    ],
    activation: [
      { muscle: 'Quadriceps', level: 'primary' },
      { muscle: 'Glutes', level: 'primary' },
      { muscle: 'Hamstrings', level: 'secondary' },
      { muscle: 'Core / Balance', level: 'stabilizer' },
      { muscle: 'Calves', level: 'stabilizer' },
    ],
  },
  'Leg Curl (Machine)': {
    steps: [
      'Lie face down on machine, adjust pad to sit just above ankles.',
      'Grip handles for stability. Keep hips pressed firmly into the pad.',
      'Curl legs toward glutes in a smooth arc — squeeze hamstrings hard at the top.',
      'Hold the contracted position for 1 second for maximum activation.',
      'Lower slowly (3 seconds) back to start. Avoid letting weight slam down.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Hips lifting off pad — reduces hamstring isolation and stresses lower back' },
      { icon: '⚠️', text: 'Using momentum — slow down, especially on the lowering phase' },
      { icon: '⚠️', text: 'Not reaching full extension — full stretch at bottom = more muscle fiber recruitment' },
      { icon: '⚠️', text: 'Too much weight — compromises form and reduces hamstring contraction quality' },
    ],
    activation: [
      { muscle: 'Hamstrings (Biceps Femoris)', level: 'primary' },
      { muscle: 'Hamstrings (Semitendinosus)', level: 'primary' },
      { muscle: 'Calves (Gastrocnemius)', level: 'secondary' },
      { muscle: 'Glutes', level: 'stabilizer' },
    ],
  },
  'Standing Calf Raise': {
    steps: [
      'Stand on edge of step with heels hanging off. Hold something for balance.',
      'Lower heels as far below step level as possible — full stretch at bottom.',
      'Rise onto toes as high as possible — full contraction at top.',
      'Hold the peak contraction for 1–2 seconds before lowering.',
      'Lower slowly (3 seconds) back to full stretch. Repeat.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Bouncing at the bottom — pause in the stretch to prevent Achilles strain' },
      { icon: '⚠️', text: 'Not reaching full range — calves respond best to complete stretch-to-contraction' },
      { icon: '⚠️', text: 'Too fast — calves need slow, controlled reps to grow' },
      { icon: '⚠️', text: 'Bending knees — keep legs straight to target gastrocnemius (outer calf)' },
    ],
    activation: [
      { muscle: 'Gastrocnemius', level: 'primary' },
      { muscle: 'Soleus', level: 'secondary' },
      { muscle: 'Tibialis Anterior', level: 'stabilizer' },
    ],
  },
  'Barbell Bench Press': {
    steps: [
      'Lie on bench with eyes under bar. Grip slightly wider than shoulder-width.',
      'Retract shoulder blades and press them into the bench — maintain this arch.',
      'Unrack bar, lower to mid-chest with elbows at ~45° angle (not flared out).',
      'Touch chest lightly — no bouncing. Press explosively back up in a slight arc.',
      'Lock out arms at top. Keep feet flat, glutes on bench throughout.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Elbows flared 90° — increases shoulder impingement risk; keep at 45°' },
      { icon: '⚠️', text: 'Bouncing bar off chest — reduces chest activation and risks injury' },
      { icon: '⚠️', text: 'Feet off the floor — reduces stability and power output' },
      { icon: '⚠️', text: 'Shoulder blades not retracted — causes shoulder pain and reduces chest activation' },
    ],
    activation: [
      { muscle: 'Pectoralis Major', level: 'primary' },
      { muscle: 'Anterior Deltoid', level: 'secondary' },
      { muscle: 'Triceps', level: 'secondary' },
      { muscle: 'Serratus Anterior', level: 'stabilizer' },
    ],
  },
  'Overhead Press (OHP)': {
    steps: [
      'Set bar at shoulder height in rack. Grip just outside shoulders, elbows slightly forward.',
      'Unrack bar, step back. Brace core hard — imagine someone is about to punch your stomach.',
      'Press bar straight up, moving head back slightly to let bar pass, then forward again.',
      'Lock out arms fully overhead. Bar should be directly over mid-foot at top.',
      'Lower with control to starting position. Breathe in on the way down.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Excessive lower back arch — brace core harder and squeeze glutes' },
      { icon: '⚠️', text: 'Bar path drifting forward — press in a straight vertical line' },
      { icon: '⚠️', text: 'Not locking out — full lockout activates upper traps and completes the rep' },
      { icon: '⚠️', text: 'Wrists bent back — keep wrists straight and stacked over elbows' },
    ],
    activation: [
      { muscle: 'Anterior Deltoid', level: 'primary' },
      { muscle: 'Lateral Deltoid', level: 'secondary' },
      { muscle: 'Triceps', level: 'secondary' },
      { muscle: 'Upper Traps', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Incline Dumbbell Press': {
    steps: [
      'Set bench to 30–45°. Sit with dumbbells on thighs, kick them up as you lie back.',
      'Hold dumbbells at shoulder level, palms facing forward, elbows at ~45°.',
      'Press dumbbells up and slightly inward — they should nearly touch at the top.',
      'Squeeze chest hard at the top — hold 1 second.',
      'Lower slowly to feel a deep stretch in upper chest. Repeat.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Bench too steep (>45°) — shifts work to shoulders, away from upper chest' },
      { icon: '⚠️', text: 'Dumbbells not touching at top — missing the peak contraction' },
      { icon: '⚠️', text: 'Elbows flaring — keep at 45° to protect shoulder joint' },
      { icon: '⚠️', text: 'Rushing the lowering phase — slow eccentric builds more muscle' },
    ],
    activation: [
      { muscle: 'Upper Pectoralis', level: 'primary' },
      { muscle: 'Anterior Deltoid', level: 'primary' },
      { muscle: 'Triceps', level: 'secondary' },
      { muscle: 'Serratus Anterior', level: 'stabilizer' },
    ],
  },
  'Cable Lateral Raise': {
    steps: [
      'Stand beside cable machine with handle at lowest setting. Hold with far hand.',
      'Slight bend in elbow — maintain this throughout. Stand tall, core braced.',
      'Raise arm out to the side, leading with your elbow (not your hand).',
      'Stop when arm is parallel to floor. Pause for 1 second at top.',
      'Lower slowly (3 seconds) — resist the cable on the way down.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Using momentum / swinging — slow down and use lighter weight' },
      { icon: '⚠️', text: 'Raising above parallel — above 90° shifts work to traps, not delts' },
      { icon: '⚠️', text: 'Thumb pointing up — tilt pinky up slightly to better target lateral delt' },
      { icon: '⚠️', text: 'Too heavy — lateral delts are small; ego lifting causes injury' },
    ],
    activation: [
      { muscle: 'Lateral Deltoid', level: 'primary' },
      { muscle: 'Anterior Deltoid', level: 'secondary' },
      { muscle: 'Supraspinatus', level: 'secondary' },
      { muscle: 'Traps', level: 'stabilizer' },
    ],
  },
  'Tricep Rope Pushdown': {
    steps: [
      'Attach rope to high cable. Grip both ends, elbows pinned to sides at ~90°.',
      'Keep elbows locked in place throughout — they should not move.',
      'Push rope down and slightly outward, fully extending arms.',
      'Squeeze triceps hard at the bottom — hold 1 second.',
      'Return slowly to start, feeling the stretch in triceps at top.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Elbows drifting forward — pin them to your sides and keep them there' },
      { icon: '⚠️', text: 'Not fully extending — partial reps miss the peak tricep contraction' },
      { icon: '⚠️', text: 'Leaning forward too much — stay upright for better isolation' },
      { icon: '⚠️', text: 'Using shoulders — if shoulders are moving, the weight is too heavy' },
    ],
    activation: [
      { muscle: 'Triceps (Long Head)', level: 'primary' },
      { muscle: 'Triceps (Lateral Head)', level: 'primary' },
      { muscle: 'Triceps (Medial Head)', level: 'secondary' },
      { muscle: 'Anconeus', level: 'stabilizer' },
    ],
  },
  'Dips (Chest-focused)': {
    steps: [
      'Grip parallel bars, arms straight. Lean torso forward ~30° for chest emphasis.',
      'Lower yourself by bending elbows, keeping the forward lean throughout.',
      'Descend until shoulders are slightly below elbows — feel the chest stretch.',
      'Press back up through palms, maintaining the forward lean.',
      'Lock out arms at top. Avoid shrugging shoulders up.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Staying upright — upright dips target triceps; lean forward for chest' },
      { icon: '⚠️', text: 'Not going deep enough — shallow dips miss the chest stretch' },
      { icon: '⚠️', text: 'Shrugging shoulders — depress and retract shoulder blades throughout' },
      { icon: '⚠️', text: 'Swinging legs — keep legs still and crossed for stability' },
    ],
    activation: [
      { muscle: 'Pectoralis Major (Lower)', level: 'primary' },
      { muscle: 'Triceps', level: 'secondary' },
      { muscle: 'Anterior Deltoid', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Pull-ups / Lat Pulldown': {
    steps: [
      'Hang from bar with overhand grip, hands wider than shoulders. Dead hang to start.',
      'Depress shoulder blades (pull them down and back) before initiating the pull.',
      'Drive elbows down toward your hips — think "elbows to back pockets".',
      'Pull until chest touches or nearly touches the bar.',
      'Lower with control over 2–3 seconds back to dead hang. Full extension each rep.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Not depressing scapula first — initiating with arms reduces lat activation' },
      { icon: '⚠️', text: 'Kipping / swinging — use strict form for muscle development' },
      { icon: '⚠️', text: 'Partial range — not reaching full extension at bottom = less lat stretch' },
      { icon: '⚠️', text: 'Chin-up vs pull-up — underhand (chin-up) = more biceps; overhand = more lats' },
    ],
    activation: [
      { muscle: 'Latissimus Dorsi', level: 'primary' },
      { muscle: 'Biceps Brachii', level: 'secondary' },
      { muscle: 'Rear Deltoid', level: 'secondary' },
      { muscle: 'Rhomboids', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Barbell Bent-Over Row': {
    steps: [
      'Stand with feet hip-width, hinge at hips to ~45°. Grip bar shoulder-width, overhand.',
      'Brace core, retract shoulder blades. Keep back flat — no rounding.',
      'Pull bar to lower chest/upper abdomen, driving elbows back and up.',
      'Squeeze shoulder blades together hard at the top — hold 1 second.',
      'Lower bar with control back to arms-extended position. Maintain hip hinge.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Rounding lower back — most dangerous mistake; reduce weight and hinge properly' },
      { icon: '⚠️', text: 'Pulling to stomach instead of chest — lower pull = less upper back activation' },
      { icon: '⚠️', text: 'Standing too upright — more horizontal torso = more lat activation' },
      { icon: '⚠️', text: 'Using biceps to pull — initiate with shoulder blades, not arms' },
    ],
    activation: [
      { muscle: 'Latissimus Dorsi', level: 'primary' },
      { muscle: 'Rhomboids / Mid Traps', level: 'primary' },
      { muscle: 'Biceps Brachii', level: 'secondary' },
      { muscle: 'Rear Deltoid', level: 'secondary' },
      { muscle: 'Spinal Erectors', level: 'stabilizer' },
    ],
  },
  'Seated Cable Row': {
    steps: [
      'Sit upright with slight forward lean, feet on platform, knees slightly bent.',
      'Grip handle with both hands. Sit tall — don\'t slouch.',
      'Pull handle to lower abdomen, driving elbows back past your torso.',
      'Squeeze shoulder blades together at the end position — hold 1 second.',
      'Extend arms fully on return, allowing shoulder blades to protract for full stretch.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Rocking back and forth — use back muscles, not momentum' },
      { icon: '⚠️', text: 'Not fully extending arms — missing the lat stretch at the front' },
      { icon: '⚠️', text: 'Pulling to chest instead of abdomen — lower pull targets mid-back better' },
      { icon: '⚠️', text: 'Shrugging shoulders — keep them depressed and retracted' },
    ],
    activation: [
      { muscle: 'Mid Trapezius', level: 'primary' },
      { muscle: 'Rhomboids', level: 'primary' },
      { muscle: 'Latissimus Dorsi', level: 'secondary' },
      { muscle: 'Biceps', level: 'secondary' },
      { muscle: 'Rear Deltoid', level: 'stabilizer' },
    ],
  },
  'Face Pull': {
    steps: [
      'Set cable at face height with rope attachment. Stand back far enough for tension.',
      'Grip rope with both hands, thumbs facing you. Step back, arms extended.',
      'Pull rope toward your face, separating hands as you pull.',
      'Elbows should be at or above shoulder height at the end position.',
      'Externally rotate at the end — hands should be beside your ears. Return slowly.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Elbows dropping below shoulders — defeats the purpose of the exercise' },
      { icon: '⚠️', text: 'Not separating the rope — the external rotation is the key movement' },
      { icon: '⚠️', text: 'Too heavy — this is a corrective/health exercise; use light weight with control' },
      { icon: '⚠️', text: 'Pulling to neck instead of face — aim for between eyes and chin' },
    ],
    activation: [
      { muscle: 'Rear Deltoid', level: 'primary' },
      { muscle: 'External Rotators', level: 'primary' },
      { muscle: 'Mid Trapezius', level: 'secondary' },
      { muscle: 'Rhomboids', level: 'secondary' },
    ],
  },
  'Dumbbell Hammer Curl': {
    steps: [
      'Stand with dumbbells at sides, palms facing each other (neutral grip).',
      'Pin elbows to sides — they should not move during the curl.',
      'Curl dumbbells up, keeping the neutral grip (thumbs pointing up) throughout.',
      'Squeeze at the top — hold 1 second.',
      'Lower slowly over 2–3 seconds back to full extension.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Swinging elbows forward — keep them pinned to your sides' },
      { icon: '⚠️', text: 'Using body momentum — if you\'re swinging, reduce the weight' },
      { icon: '⚠️', text: 'Rotating to supinated grip — keep neutral grip to target brachialis' },
      { icon: '⚠️', text: 'Not lowering fully — full extension at bottom maximizes bicep stretch' },
    ],
    activation: [
      { muscle: 'Brachialis', level: 'primary' },
      { muscle: 'Biceps Brachii', level: 'primary' },
      { muscle: 'Brachioradialis', level: 'secondary' },
      { muscle: 'Forearm Flexors', level: 'stabilizer' },
    ],
  },
  'Single-Arm Dumbbell Row': {
    steps: [
      'Place one knee and same-side hand on bench. Other foot on floor for stability.',
      'Hold dumbbell in free hand, arm hanging straight down. Back parallel to floor.',
      'Pull dumbbell toward your hip, driving elbow back and up.',
      'Squeeze lat at the top — think about putting your elbow in your back pocket.',
      'Lower with control to full arm extension. Don\'t let shoulder drop at bottom.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Rotating torso to lift — keep hips and shoulders square to the bench' },
      { icon: '⚠️', text: 'Pulling toward chest — pull toward hip for better lat activation' },
      { icon: '⚠️', text: 'Shoulder dropping at bottom — keep it packed (slightly elevated) throughout' },
      { icon: '⚠️', text: 'Rushing — slow eccentric (lowering) builds more muscle' },
    ],
    activation: [
      { muscle: 'Latissimus Dorsi', level: 'primary' },
      { muscle: 'Rhomboids', level: 'secondary' },
      { muscle: 'Biceps', level: 'secondary' },
      { muscle: 'Rear Deltoid', level: 'secondary' },
      { muscle: 'Core (Anti-rotation)', level: 'stabilizer' },
    ],
  },
  'Hip Thrust': {
    steps: [
      'Sit on floor with upper back against bench edge. Roll barbell over legs to hips.',
      'Place feet flat, hip-width apart. Pad the bar for comfort.',
      'Drive through heels, thrusting hips up until body forms a straight line.',
      'Squeeze glutes HARD at the top — hold for 2 seconds.',
      'Lower hips slowly back down. Don\'t let them touch the floor between reps.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Not squeezing glutes at top — the squeeze IS the exercise; don\'t skip it' },
      { icon: '⚠️', text: 'Hyperextending lower back — ribs should stay down, pelvis neutral at top' },
      { icon: '⚠️', text: 'Feet too close — creates knee pain; feet should be far enough that shins are vertical at top' },
      { icon: '⚠️', text: 'Chin tucked to chest — keep neutral neck, gaze slightly forward' },
    ],
    activation: [
      { muscle: 'Gluteus Maximus', level: 'primary' },
      { muscle: 'Hamstrings', level: 'secondary' },
      { muscle: 'Quadriceps', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
      { muscle: 'Hip Flexors', level: 'stabilizer' },
    ],
  },
  'Deadlift': {
    steps: [
      'Bar over mid-foot (1 inch from shins). Feet hip-width, toes slightly out.',
      'Hinge down, grip bar just outside legs. Chest up, lats tight ("protect your armpits").',
      'Take a big breath, brace core 360°. Push floor away — don\'t think "pull".',
      'Bar stays in contact with legs the entire way up. Hips and shoulders rise together.',
      'Lock out hips at top — squeeze glutes. Lower by hinging hips back first, then bending knees.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Bar away from body — creates a lever that multiplies lower back stress' },
      { icon: '⚠️', text: 'Hips rising faster than shoulders — turns it into a stiff-leg deadlift' },
      { icon: '⚠️', text: 'Jerking the bar — build tension first, then lift smoothly' },
      { icon: '⚠️', text: 'Rounding lower back — most dangerous; reduce weight and fix form first' },
    ],
    activation: [
      { muscle: 'Spinal Erectors', level: 'primary' },
      { muscle: 'Glutes', level: 'primary' },
      { muscle: 'Hamstrings', level: 'primary' },
      { muscle: 'Quadriceps', level: 'secondary' },
      { muscle: 'Traps / Lats', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Burpees': {
    steps: [
      'Stand tall. Drop hands to floor just outside feet.',
      'Jump or step feet back to plank position — body straight.',
      'Perform a push-up (optional for beginners: skip it).',
      'Jump feet forward to hands, landing in squat position.',
      'Explode upward, jumping as high as possible with arms overhead. Land softly.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Hips sagging in plank — keep core tight and body in straight line' },
      { icon: '⚠️', text: 'Landing hard — absorb impact with bent knees to protect joints' },
      { icon: '⚠️', text: 'Rushing at expense of form — quality reps beat sloppy fast reps' },
      { icon: '⚠️', text: 'Not fully extending at jump — reach arms overhead for full range' },
    ],
    activation: [
      { muscle: 'Quadriceps', level: 'primary' },
      { muscle: 'Chest / Triceps', level: 'primary' },
      { muscle: 'Glutes', level: 'secondary' },
      { muscle: 'Shoulders', level: 'secondary' },
      { muscle: 'Core', level: 'stabilizer' },
    ],
  },
  'Plank': {
    steps: [
      'Place forearms on floor, elbows directly under shoulders. Feet together.',
      'Lift hips to form a straight line from head to heels — no sagging or piking.',
      'Squeeze glutes hard. Brace abs as if bracing for a punch.',
      'Keep neck neutral — don\'t look up or tuck chin to chest.',
      'Breathe steadily. Hold for prescribed time. If form breaks, rest and repeat.',
    ],
    mistakes: [
      { icon: '⚠️', text: 'Hips sagging — most common; squeeze glutes and brace core harder' },
      { icon: '⚠️', text: 'Hips too high (piking) — lower them to form a straight line' },
      { icon: '⚠️', text: 'Holding breath — breathe steadily throughout' },
      { icon: '⚠️', text: 'Elbows too far forward — keep them directly under shoulders' },
    ],
    activation: [
      { muscle: 'Transverse Abdominis', level: 'primary' },
      { muscle: 'Rectus Abdominis', level: 'secondary' },
      { muscle: 'Glutes', level: 'secondary' },
      { muscle: 'Shoulder Stabilizers', level: 'secondary' },
      { muscle: 'Spinal Erectors', level: 'stabilizer' },
    ],
  },
};

// ─── Routines Data ─────────────────────────────────────────────────────────────
const ROUTINES = {
  leg_day: {
    label: 'Leg Day',
    icon: 'Dumbbell',
    color: 'text-orange-500',
    bg: 'bg-orange-500/10',
    border: 'border-orange-500/30',
    description: 'Focus on quads, hamstrings, glutes and calves. Compound movements first, isolation last.',
    exercises: [
      { name: 'Barbell Back Squat', sets: '4 sets × 8–10 reps', rest: '2–3 min', muscles: 'Quads, Glutes, Hamstrings, Core', how: 'Stand with feet shoulder-width apart, bar on upper traps. Descend until thighs are parallel to floor, keeping chest up and knees tracking over toes. Drive through heels to stand.' },
      { name: 'Romanian Deadlift', sets: '3 sets × 10–12 reps', rest: '2 min', muscles: 'Hamstrings, Glutes, Lower Back', how: 'Hold barbell at hip level, hinge at hips pushing them back while lowering the bar along your legs. Keep back flat and slight knee bend. Feel the stretch in hamstrings, then drive hips forward to return.' },
      { name: 'Leg Press', sets: '3 sets × 12–15 reps', rest: '90 sec', muscles: 'Quads, Glutes', how: 'Sit in machine with feet shoulder-width on platform. Lower weight until knees reach 90°, then press through heels. Avoid locking knees at top.' },
      { name: 'Walking Lunges', sets: '3 sets × 12 reps each leg', rest: '90 sec', muscles: 'Quads, Glutes, Hamstrings, Balance', how: 'Step forward into a lunge, lower back knee toward floor without touching. Push off front foot to bring back leg forward into next lunge. Keep torso upright.' },
      { name: 'Leg Curl (Machine)', sets: '3 sets × 12–15 reps', rest: '60 sec', muscles: 'Hamstrings', how: 'Lie face down on machine, pad behind ankles. Curl legs toward glutes squeezing hamstrings at top. Lower slowly with control.' },
      { name: 'Standing Calf Raise', sets: '4 sets × 15–20 reps', rest: '60 sec', muscles: 'Gastrocnemius, Soleus', how: 'Stand on edge of step with heels hanging off. Rise onto toes as high as possible, hold 1 sec, then lower heels below step level for full stretch.' },
    ],
  },
  push: {
    label: 'Push',
    icon: 'ArrowUp',
    color: 'text-blue-500',
    bg: 'bg-blue-500/10',
    border: 'border-blue-500/30',
    description: 'Targets chest, shoulders and triceps. Push movements that drive weight away from your body.',
    exercises: [
      { name: 'Barbell Bench Press', sets: '4 sets × 6–8 reps', rest: '3 min', muscles: 'Chest, Front Delts, Triceps', how: 'Lie on bench, grip slightly wider than shoulder-width. Lower bar to mid-chest with elbows at ~45°. Press explosively back up. Keep shoulder blades retracted and feet flat.' },
      { name: 'Overhead Press (OHP)', sets: '3 sets × 8–10 reps', rest: '2 min', muscles: 'Shoulders, Triceps, Upper Chest', how: 'Stand with bar at shoulder height, grip just outside shoulders. Press bar straight overhead until arms lock out. Lower with control. Brace core throughout.' },
      { name: 'Incline Dumbbell Press', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Upper Chest, Front Delts', how: 'Set bench to 30–45°. Press dumbbells from shoulder level up and slightly inward. Squeeze chest at top. Lower slowly to feel stretch.' },
      { name: 'Cable Lateral Raise', sets: '3 sets × 12–15 reps', rest: '60 sec', muscles: 'Lateral Delts', how: 'Stand beside cable machine, hold handle with far hand. Raise arm out to side until parallel to floor, leading with elbow. Lower slowly.' },
      { name: 'Tricep Rope Pushdown', sets: '3 sets × 12–15 reps', rest: '60 sec', muscles: 'Triceps', how: 'Grip rope at chest height, elbows pinned to sides. Push rope down and slightly outward until arms fully extend. Squeeze triceps at bottom. Return slowly.' },
      { name: 'Dips (Chest-focused)', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Chest, Triceps, Front Delts', how: 'Lean slightly forward on parallel bars. Lower until shoulders are below elbows. Press back up. Leaning forward shifts emphasis to chest.' },
    ],
  },
  pull: {
    label: 'Pull',
    icon: 'ArrowDown',
    color: 'text-purple-500',
    bg: 'bg-purple-500/10',
    border: 'border-purple-500/30',
    description: 'Targets back, biceps and rear delts. Pulling movements that bring weight toward your body.',
    exercises: [
      { name: 'Pull-ups / Lat Pulldown', sets: '4 sets × 6–10 reps', rest: '2–3 min', muscles: 'Lats, Biceps, Rear Delts', how: 'Hang from bar with overhand grip wider than shoulders. Pull chest toward bar driving elbows down and back. Lower with control. For pulldown: same motion on cable machine.' },
      { name: 'Barbell Bent-Over Row', sets: '4 sets × 8–10 reps', rest: '2 min', muscles: 'Mid Back, Lats, Biceps', how: 'Hinge at hips ~45°, grip bar shoulder-width. Pull bar to lower chest. Squeeze shoulder blades together at top. Lower slowly. Keep back flat.' },
      { name: 'Seated Cable Row', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Mid Back, Rhomboids, Biceps', how: 'Sit upright, pull handle to lower abdomen. Squeeze shoulder blades at end. Extend arms fully on return for full stretch. Avoid rounding back.' },
      { name: 'Face Pull', sets: '3 sets × 15 reps', rest: '60 sec', muscles: 'Rear Delts, External Rotators', how: 'Set cable at face height with rope. Pull rope toward face, separating hands at end. Elbows should be at or above shoulder height. Great for shoulder health.' },
      { name: 'Dumbbell Hammer Curl', sets: '3 sets × 10–12 reps', rest: '60 sec', muscles: 'Biceps, Brachialis', how: 'Hold dumbbells with neutral grip (thumbs up). Curl up keeping elbows pinned to sides. Squeeze at top. Lower slowly. Neutral grip targets brachialis for arm thickness.' },
      { name: 'Single-Arm Dumbbell Row', sets: '3 sets × 10–12 reps each', rest: '60 sec', muscles: 'Lats, Mid Back, Biceps', how: 'Place one knee and hand on bench. Pull dumbbell to hip, driving elbow back. Squeeze lat at top. Lower with control. Keep back parallel to floor.' },
    ],
  },
  upper_body: {
    label: 'Upper Body',
    icon: 'Activity',
    color: 'text-cyan-500',
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    description: 'Complete upper body session combining push and pull movements for balanced development.',
    exercises: [
      { name: 'Bench Press', sets: '3 sets × 8–10 reps', rest: '2 min', muscles: 'Chest, Triceps, Front Delts', how: 'Lie on bench, lower bar to mid-chest with elbows at 45°. Press up explosively. Keep shoulder blades retracted throughout.' },
      { name: 'Bent-Over Row', sets: '3 sets × 8–10 reps', rest: '2 min', muscles: 'Back, Biceps, Rear Delts', how: 'Hinge at hips, pull bar to lower chest. Squeeze shoulder blades together at top. Lower with control. Superset with bench press for efficiency.' },
      { name: 'Dumbbell Shoulder Press', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Shoulders, Triceps', how: 'Sit or stand, press dumbbells from ear level overhead. Avoid arching lower back. Lower to 90° and repeat.' },
      { name: 'Lat Pulldown', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Lats, Biceps', how: 'Pull bar to upper chest, driving elbows down. Lean back slightly. Squeeze lats at bottom. Extend arms fully on return.' },
      { name: 'Tricep Dips or Pushdown', sets: '3 sets × 12 reps', rest: '60 sec', muscles: 'Triceps', how: 'For dips: keep torso upright to target triceps. For pushdown: elbows pinned, push rope down fully extending arms.' },
      { name: 'Barbell or Dumbbell Curl', sets: '3 sets × 12 reps', rest: '60 sec', muscles: 'Biceps', how: 'Curl weight up keeping elbows stationary at sides. Squeeze biceps at top. Lower slowly for 2–3 seconds.' },
    ],
  },
  lower_body: {
    label: 'Lower Body',
    icon: 'TrendingDown',
    color: 'text-yellow-500',
    bg: 'bg-yellow-500/10',
    border: 'border-yellow-500/30',
    description: 'Complete lower body session targeting quads, hamstrings, glutes and calves with varied angles.',
    exercises: [
      { name: 'Goblet Squat', sets: '3 sets × 12 reps', rest: '90 sec', muscles: 'Quads, Glutes, Core', how: 'Hold dumbbell or kettlebell at chest. Squat deep with elbows inside knees. Keep chest tall. Great for mobility and quad activation.' },
      { name: 'Hip Thrust', sets: '4 sets × 10–12 reps', rest: '2 min', muscles: 'Glutes, Hamstrings', how: 'Upper back on bench, barbell across hips. Drive hips up squeezing glutes hard at top. Hold 1 sec. Lower slowly. Best glute builder.' },
      { name: 'Bulgarian Split Squat', sets: '3 sets × 10 reps each leg', rest: '90 sec', muscles: 'Quads, Glutes, Balance', how: 'Rear foot elevated on bench, front foot forward. Lower back knee toward floor. Keep front shin vertical. Hold dumbbells for added resistance.' },
      { name: 'Leg Curl', sets: '3 sets × 12–15 reps', rest: '60 sec', muscles: 'Hamstrings', how: 'Lying or seated machine. Curl legs squeezing hamstrings. Lower slowly. Full range of motion is key.' },
      { name: 'Sumo Deadlift', sets: '3 sets × 8 reps', rest: '2 min', muscles: 'Glutes, Inner Thighs, Hamstrings', how: 'Wide stance, toes pointed out. Grip bar inside legs. Keep chest up, drive through heels. Sumo stance emphasizes glutes and adductors.' },
      { name: 'Seated Calf Raise', sets: '4 sets × 15–20 reps', rest: '60 sec', muscles: 'Soleus (deep calf)', how: 'Seated with pad on lower thighs. Rise onto toes, hold 1 sec, lower fully. Seated position targets soleus more than standing.' },
    ],
  },
  full_body: {
    label: 'Full Body',
    icon: 'Zap',
    color: 'text-green-500',
    bg: 'bg-green-500/10',
    border: 'border-green-500/30',
    description: 'Efficient full body session hitting all major muscle groups. Ideal 3× per week for general fitness.',
    exercises: [
      { name: 'Deadlift', sets: '3 sets × 5–6 reps', rest: '3 min', muscles: 'Full Posterior Chain, Quads, Core', how: 'Bar over mid-foot, grip just outside legs. Hinge and grip, chest up, lats tight. Drive floor away, keeping bar close to body. Lock out hips at top.' },
      { name: 'Squat', sets: '3 sets × 8 reps', rest: '2 min', muscles: 'Quads, Glutes, Core', how: 'Feet shoulder-width, descend until thighs parallel. Drive through heels. Keep chest up and core braced.' },
      { name: 'Push-ups or Bench Press', sets: '3 sets × 10–12 reps', rest: '90 sec', muscles: 'Chest, Triceps, Shoulders', how: 'For push-ups: hands slightly wider than shoulders, body straight. Lower chest to floor. For bench: standard technique with controlled tempo.' },
      { name: 'Pull-ups or Lat Pulldown', sets: '3 sets × 8–10 reps', rest: '90 sec', muscles: 'Back, Biceps', how: 'Pull chest toward bar or pull bar to chest. Drive elbows down and back. Full extension at bottom.' },
      { name: 'Overhead Press', sets: '3 sets × 8–10 reps', rest: '90 sec', muscles: 'Shoulders, Triceps', how: 'Press bar or dumbbells overhead from shoulder level. Lock out at top. Lower with control.' },
      { name: 'Plank', sets: '3 sets × 45–60 sec', rest: '60 sec', muscles: 'Core, Shoulders, Glutes', how: 'Forearms on floor, body in straight line from head to heels. Squeeze glutes and abs. Breathe steadily. Avoid hips sagging or rising.' },
    ],
  },
  cardio: {
    label: 'Cardio',
    icon: 'Heart',
    color: 'text-red-500',
    bg: 'bg-red-500/10',
    border: 'border-red-500/30',
    description: 'Steady-state cardiovascular training to improve endurance, heart health and burn calories.',
    exercises: [
      { name: 'Warm-up Walk/Jog', sets: '1 × 5 min', rest: 'None', muscles: 'Cardiovascular System, Legs', how: 'Start at easy pace to raise heart rate gradually. Aim for 50–60% max HR. Prepares joints and muscles for higher intensity.' },
      { name: 'Steady-State Run', sets: '1 × 20–30 min', rest: 'None', muscles: 'Legs, Cardiovascular System', how: 'Maintain conversational pace (60–70% max HR). You should be able to speak in short sentences. Land mid-foot, keep shoulders relaxed.' },
      { name: 'Cycling (Bike or Spin)', sets: '1 × 20–30 min', rest: 'None', muscles: 'Quads, Glutes, Cardiovascular', how: 'Maintain steady cadence (80–100 RPM). Adjust resistance to keep HR in aerobic zone. Low impact on joints.' },
      { name: 'Jump Rope', sets: '5 × 3 min', rest: '60 sec between rounds', muscles: 'Calves, Shoulders, Cardiovascular', how: 'Jump with both feet, wrists doing the rotation not arms. Land softly on balls of feet. Start with basic bounce, progress to alternating feet.' },
      { name: 'Rowing Machine', sets: '1 × 15–20 min', rest: 'None', muscles: 'Full Body, Cardiovascular', how: 'Drive with legs first, then lean back, then pull arms. Reverse on return: arms, lean forward, legs. Maintain steady rhythm at 22–26 strokes/min.' },
      { name: 'Cool-down Walk + Stretch', sets: '1 × 5–10 min', rest: 'None', muscles: 'Full Body Recovery', how: 'Slow to walking pace to bring HR down. Follow with static stretches held 30 sec each: hip flexors, quads, calves, hamstrings.' },
    ],
  },
  hiit: {
    label: 'HIIT',
    icon: 'Flame',
    color: 'text-rose-500',
    bg: 'bg-rose-500/10',
    border: 'border-rose-500/30',
    description: 'High-Intensity Interval Training. Alternates max effort bursts with short rest. Burns fat efficiently in less time.',
    exercises: [
      { name: 'Burpees', sets: '4 rounds × 40 sec on / 20 sec off', rest: '20 sec', muscles: 'Full Body, Cardiovascular', how: 'From standing, drop hands to floor, jump feet back to plank, do a push-up, jump feet forward, then jump up with arms overhead. Move as fast as possible with good form.' },
      { name: 'Jump Squats', sets: '4 rounds × 40 sec on / 20 sec off', rest: '20 sec', muscles: 'Quads, Glutes, Cardiovascular', how: 'Squat down, then explode upward jumping as high as possible. Land softly with bent knees. Immediately descend into next squat.' },
      { name: 'Mountain Climbers', sets: '4 rounds × 40 sec on / 20 sec off', rest: '20 sec', muscles: 'Core, Shoulders, Cardiovascular', how: 'Start in plank position. Drive knees alternately toward chest as fast as possible. Keep hips level and core tight.' },
      { name: 'High Knees', sets: '4 rounds × 40 sec on / 20 sec off', rest: '20 sec', muscles: 'Hip Flexors, Quads, Cardiovascular', how: 'Run in place driving knees up to hip height. Pump arms in opposition. Stay on balls of feet. Maximum speed.' },
      { name: 'Push-up to Shoulder Tap', sets: '3 rounds × 40 sec on / 20 sec off', rest: '20 sec', muscles: 'Chest, Shoulders, Core', how: 'Do a push-up, then at top tap each shoulder with opposite hand. Keep hips stable during taps. Modify on knees if needed.' },
      { name: 'Sprint Intervals', sets: '8 × 20 sec sprint / 40 sec walk', rest: '40 sec walk', muscles: 'Full Body, Cardiovascular', how: 'Sprint at 90–100% effort for 20 sec, then walk to recover. Outdoors or treadmill. This is the classic Tabata-style protocol.' },
    ],
  },
  yoga: {
    label: 'Yoga',
    icon: 'Leaf',
    color: 'text-teal-500',
    bg: 'bg-teal-500/10',
    border: 'border-teal-500/30',
    description: 'Combines breath, movement and mindfulness. Improves flexibility, balance, and mental clarity.',
    exercises: [
      { name: "Child's Pose (Balasana)", sets: 'Hold 60–90 sec', rest: 'Transition to next pose', muscles: 'Hips, Lower Back, Shoulders', how: 'Kneel, sit back on heels, extend arms forward on mat. Rest forehead down. Breathe deeply into back body. Excellent opening and resting pose.' },
      { name: 'Downward Facing Dog', sets: 'Hold 30–60 sec × 3', rest: 'Transition', muscles: 'Hamstrings, Calves, Shoulders, Back', how: 'From plank, push hips up and back forming inverted V. Press heels toward floor. Spread fingers wide. Pedal feet to warm up hamstrings.' },
      { name: 'Warrior I (Virabhadrasana I)', sets: 'Hold 30–45 sec each side', rest: 'Transition', muscles: 'Hip Flexors, Quads, Shoulders', how: 'Step one foot forward into lunge, back foot at 45°. Raise arms overhead, square hips forward. Bend front knee to 90°. Gaze forward or up.' },
      { name: 'Warrior II (Virabhadrasana II)', sets: 'Hold 30–45 sec each side', rest: 'Transition', muscles: 'Inner Thighs, Quads, Shoulders', how: 'Wide stance, front foot forward, back foot perpendicular. Arms extended parallel to floor. Gaze over front hand. Open hips to side.' },
      { name: 'Pigeon Pose', sets: 'Hold 60–90 sec each side', rest: 'Transition', muscles: 'Hip Flexors, Glutes, IT Band', how: 'From downward dog, bring one knee forward behind wrist. Extend back leg. Lower hips toward floor. Fold forward for deeper stretch. Breathe into tightness.' },
      { name: 'Seated Forward Fold (Paschimottanasana)', sets: 'Hold 60–90 sec', rest: 'End of session', muscles: 'Hamstrings, Lower Back, Calves', how: 'Sit with legs extended. Inhale to lengthen spine, exhale fold forward reaching for feet. Hold shins or feet. Relax neck. Each exhale deepen the fold.' },
    ],
  },
};

// ─── Exercise Card ─────────────────────────────────────────────────────────────
const ExerciseCard = ({ exercise, index }) => {
  const [expanded, setExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState('steps');

  const details = EXERCISE_DETAILS?.[exercise?.name];

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className="border border-border/40 rounded-xl overflow-hidden"
    >
      {/* Card Header */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 hover:bg-muted/30 transition-colors text-left"
      >
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center mt-0.5">
            {index + 1}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-foreground truncate">{exercise?.name}</p>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              <span className="inline-flex items-center gap-1 text-xs text-primary font-medium">
                <Icon name="Repeat" size={11} />
                {exercise?.sets}
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
                <Icon name="Clock" size={11} />
                Rest: {exercise?.rest}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 ml-2">
          {details && (
            <span className="text-xs bg-primary/10 text-primary px-1.5 py-0.5 rounded-md font-medium hidden sm:inline">
              Guide
            </span>
          )}
          <Icon
            name={expanded ? 'ChevronUp' : 'ChevronDown'}
            size={14}
            className="text-muted-foreground"
          />
        </div>
      </button>
      {/* Expanded Content */}
      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className="border-t border-border/30">
              {/* SVG Illustration + Basic Info */}
              <div className="flex gap-3 p-3 bg-muted/10">
                {/* SVG Illustration */}
                <div className="flex-shrink-0 w-24 h-20 bg-card rounded-lg border border-border/30 p-1 flex items-center justify-center overflow-hidden">
                  <ExerciseSVG exerciseName={exercise?.name} />
                </div>
                {/* Muscles */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <Icon name="Target" size={12} className="text-muted-foreground flex-shrink-0" />
                    <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Muscles Worked</p>
                  </div>
                  <p className="text-xs text-foreground leading-relaxed">{exercise?.muscles}</p>
                  <div className="mt-2 flex items-center gap-1.5">
                    <Icon name="BookOpen" size={12} className="text-muted-foreground flex-shrink-0" />
                    <p className="text-xs text-muted-foreground leading-relaxed line-clamp-2">{exercise?.how}</p>
                  </div>
                </div>
              </div>

              {/* Enhanced Guide Tabs (only if details exist) */}
              {details && (
                <div className="px-3 pb-3">
                  {/* Tab Buttons */}
                  <div className="flex gap-1 mt-3 mb-3 bg-muted/30 rounded-lg p-1">
                    {[
                      { id: 'steps', label: 'Steps', icon: 'ListChecks' },
                      { id: 'mistakes', label: 'Mistakes', icon: 'AlertTriangle' },
                      { id: 'activation', label: 'Muscles', icon: 'Zap' },
                    ]?.map((tab) => (
                      <button
                        key={tab?.id}
                        onClick={() => setActiveTab(tab?.id)}
                        className={`flex-1 flex items-center justify-center gap-1 py-1.5 px-2 rounded-md text-xs font-medium transition-all duration-200 ${
                          activeTab === tab?.id
                            ? 'bg-card text-foreground shadow-sm'
                            : 'text-muted-foreground hover:text-foreground'
                        }`}
                      >
                        <Icon name={tab?.icon} size={11} />
                        <span className="hidden sm:inline">{tab?.label}</span>
                        <span className="sm:hidden">{tab?.label?.slice(0, 4)}</span>
                      </button>
                    ))}
                  </div>

                  {/* Tab Content */}
                  <AnimatePresence mode="wait">
                    {activeTab === 'steps' && (
                      <motion.div
                        key="steps"
                        initial={{ opacity: 0, x: -8 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 8 }}
                        transition={{ duration: 0.15 }}
                        className="space-y-2"
                      >
                        <p className="text-xs font-semibold text-foreground flex items-center gap-1.5 mb-2">
                          <Icon name="ListChecks" size={13} className="text-primary" />
                          Step-by-Step Execution
                        </p>
                        {details?.steps?.map((step, i) => (
                          <div key={i} className="flex gap-2.5">
                            <span className="flex-shrink-0 w-5 h-5 rounded-full bg-primary/15 text-primary text-xs font-bold flex items-center justify-center mt-0.5">
                              {i + 1}
                            </span>
                            <p className="text-xs text-foreground/85 leading-relaxed">{step}</p>
                          </div>
                        ))}
                      </motion.div>
                    )}

                    {activeTab === 'mistakes' && (
                      <motion.div
                        key="mistakes"
                        initial={{ opacity: 0, x: -8 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 8 }}
                        transition={{ duration: 0.15 }}
                        className="space-y-2"
                      >
                        <p className="text-xs font-semibold text-foreground flex items-center gap-1.5 mb-2">
                          <Icon name="AlertTriangle" size={13} className="text-amber-500" />
                          Common Mistakes to Avoid
                        </p>
                        {details?.mistakes?.map((mistake, i) => (
                          <div key={i} className="flex gap-2 bg-amber-500/5 border border-amber-500/20 rounded-lg p-2">
                            <span className="text-sm flex-shrink-0">{mistake?.icon}</span>
                            <p className="text-xs text-foreground/85 leading-relaxed">{mistake?.text}</p>
                          </div>
                        ))}
                      </motion.div>
                    )}

                    {activeTab === 'activation' && (
                      <motion.div
                        key="activation"
                        initial={{ opacity: 0, x: -8 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 8 }}
                        transition={{ duration: 0.15 }}
                        className="space-y-2"
                      >
                        <p className="text-xs font-semibold text-foreground flex items-center gap-1.5 mb-2">
                          <Icon name="Zap" size={13} className="text-orange-500" />
                          Muscle Activation Map
                        </p>
                        <div className="space-y-2">
                          {details?.activation?.map((item, i) => (
                            <MuscleActivationBar key={i} muscle={item?.muscle} level={item?.level} />
                          ))}
                        </div>
                        {/* Legend */}
                        <div className="flex gap-3 mt-3 pt-2 border-t border-border/30">
                          {[
                            { color: 'bg-orange-500', label: 'Primary' },
                            { color: 'bg-blue-400', label: 'Secondary' },
                            { color: 'bg-green-400', label: 'Stabilizer' },
                          ]?.map((item) => (
                            <div key={item?.label} className="flex items-center gap-1">
                              <div className={`w-2 h-2 rounded-full ${item?.color}`} />
                              <span className="text-xs text-muted-foreground">{item?.label}</span>
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              )}

              {/* Fallback if no details */}
              {!details && (
                <div className="px-3 pb-3 pt-2">
                  <div className="flex items-start gap-2">
                    <Icon name="BookOpen" size={13} className="text-muted-foreground mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-0.5">How to perform</p>
                      <p className="text-xs text-foreground leading-relaxed">{exercise?.how}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

// ─── Main Component ────────────────────────────────────────────────────────────
const WorkoutRoutinesGuide = ({ selectedType, onClose }) => {
  const [activeWorkout, setActiveWorkout] = useState(selectedType || 'leg_day');

  const routine = ROUTINES?.[activeWorkout];
  const workoutKeys = Object.keys(ROUTINES);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 12 }}
      transition={{ duration: 0.3 }}
      className="bg-card rounded-xl border border-border/40 shadow-wellness overflow-hidden"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-4 border-b border-border/40">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-9 h-9 bg-primary/10 rounded-lg">
            <Icon name="BookOpen" size={18} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground text-sm">Routines Guide</h3>
            <p className="text-xs text-muted-foreground">Tap exercises for step-by-step guides & muscle maps</p>
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-muted/50 transition-colors text-muted-foreground hover:text-foreground"
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </div>
      {/* Workout type selector */}
      <div className="px-5 pt-4">
        <div className="flex gap-1.5 flex-wrap">
          {workoutKeys?.map((key) => {
            const r = ROUTINES?.[key];
            const isActive = activeWorkout === key;
            return (
              <button
                key={key}
                onClick={() => setActiveWorkout(key)}
                className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all duration-200 border ${
                  isActive
                    ? `${r?.bg} ${r?.border} ${r?.color} border`
                    : 'border-border/40 text-muted-foreground hover:border-border hover:bg-muted/30'
                }`}
              >
                <Icon name={r?.icon} size={12} className={isActive ? r?.color : 'text-muted-foreground'} />
                {r?.label}
              </button>
            );
          })}
        </div>
      </div>
      {/* Routine content */}
      <div className="p-5 space-y-4">
        {/* Routine header */}
        <div className={`flex items-start gap-3 p-3 rounded-lg ${routine?.bg} border ${routine?.border}`}>
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-card/60">
            <Icon name={routine?.icon} size={16} className={routine?.color} />
          </div>
          <div>
            <p className={`text-sm font-bold ${routine?.color}`}>{routine?.label}</p>
            <p className="text-xs text-foreground/80 mt-0.5 leading-relaxed">{routine?.description}</p>
          </div>
        </div>

        {/* Legend */}
        <div className="flex items-center gap-3 text-xs text-muted-foreground bg-muted/20 rounded-lg px-3 py-2">
          <Icon name="Info" size={12} className="flex-shrink-0" />
          <span>Tap any exercise to see SVG illustration, step-by-step guide, common mistakes & muscle activation map</span>
        </div>

        {/* Exercises */}
        <div className="space-y-2">
          {routine?.exercises?.map((exercise, index) => (
            <ExerciseCard key={exercise?.name} exercise={exercise} index={index} />
          ))}
        </div>

        {/* Tip */}
        <div className="flex items-start gap-2 bg-primary/5 border border-primary/20 rounded-lg p-3">
          <Icon name="Lightbulb" size={14} className="text-primary mt-0.5 flex-shrink-0" />
          <p className="text-xs text-foreground/80 leading-relaxed">
            <span className="font-semibold text-foreground">Progressive overload tip:</span> Aim to increase weight by 2.5–5kg or add 1–2 reps each week. Track your lifts in the Progressive Overload tab.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default WorkoutRoutinesGuide;
